import React from 'react';
import {isNullOrUndefined, isOtherBillUser, Step, Stepper} from "../common";
import GeneralData from "./components/general-data/GeneralData";
import {useNewReportState} from "./NewReportContext";
import SelectPayment from "./components/select-payment-step/SelectPayment";
import SelectPricingPlan from "./components/select-pricing-plan-step/SelectPricingPlan";
import {pick} from "../common/helpers/utils";
import Resume from "./components/resume-step/Resume";
import DispatchData  from './components/dispatch-data/DispatchData';

export const NewReport = (props) => {
  const {
    planDataRef, 
    validateGeneralData,
    validateDispatchData,
    uiState,
    dataState,
    onCancel,
    updateBillInfo,
    deleteBillInfo,
    updatePaymentType,
    validatePaymentSelected,
    validatePlanSelected,
    onBackPlanStep,
    onUpdatePlanData,
    onNewRequest,
    disableFinishBtn,
    onChangeAcceptTermAndConditionsAction,
    onBackDispatchStep
  } = useNewReportState();

  const paymentErrorMessage = ['Es requerido que seleccione un medio de pago.'];

  return (
    <Stepper  
      finishButtonText="Pagar"
      onFinish={onNewRequest}
      onCancel={onCancel}
      onFinishDisabled={disableFinishBtn || !uiState.acceptTermAndConditions}>
      <Step
        title="Datos Generales"
        subTitle="Ingrese los datos solicitados"
        onValidateNext={validateGeneralData}
        error={uiState.generalDataStepErrors.length > 0}
        isDirty={uiState.generalDataStepIsDirty}>
        <GeneralData/>
      </Step>
      <Step
        title="Datos Despacho"
        subTitle="Ingrese los datos"
        onValidateNext={validateDispatchData}
        onBack={onBackDispatchStep}
        error={uiState.dispatchStepErrors.length > 0}        
        isDirty={uiState.dispatchStepIsDirty}>
        <DispatchData/>
      </Step>
      <Step
        title="Planes"
        subTitle="Seleccione su plan"
        error={uiState.planStepErrors.length > 0}
        errorMessage={uiState.planStepErrors}
        isDirty={uiState.planStepIsDirty}
        onValidateNext={validatePlanSelected}
        onBack={onBackPlanStep}>
        <SelectPricingPlan
          ref={planDataRef}
          isOtherBillUser={isOtherBillUser(dataState.billIssuerSelected)}
          onUpdatePlanData={onUpdatePlanData}
          plansAvailable={dataState.plansAvailable}
          licenseNumbersAvailable={dataState.licenseNumbersAvailable}
          initialValues={pick(dataState, ['planSelected', 'licenseNumber'])}
        />
      </Step>
      <Step
        title="Forma de Pago"
        subTitle="Seleccione su forma de pago"
        error={isNullOrUndefined(dataState.paymentType)}
        errorMessage={paymentErrorMessage}
        isDirty={uiState.paymentStepIsDirty}
        onValidateNext={validatePaymentSelected}>
        <SelectPayment
          paymentType={dataState.paymentType}
          billInfo={dataState.billInfo}
          onEditBillInfo={updateBillInfo}
          onRemoveBillInfo={deleteBillInfo}
          onEditPaymentType={updatePaymentType}/>
      </Step>
      <Step
        title="Resumen"
        subTitle="Verifique los datos">
        <Resume
          onChangeAcceptTermAndConditionsAction={onChangeAcceptTermAndConditionsAction}
          dataState={dataState}
          uiState={uiState}/>
      </Step>
    </Stepper>
  );
};

NewReport.propTypes = {}

NewReport.defaultProps = {}

export default NewReport;
